import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class IconsService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}

  registerIcon() {
    const urlPrefix = '../assets/brand/';
    this.matIconRegistry.addSvgIcon(
      'cm-cloud-imagotype',
      this.domSanitizer.bypassSecurityTrustResourceUrl(urlPrefix + 'INNOVATROVE-imagotype1.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'cm-cloud-isotype',
      this.domSanitizer.bypassSecurityTrustResourceUrl(urlPrefix + 'INNOVATROVE-isotype.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'in-progress',
      this.domSanitizer.bypassSecurityTrustResourceUrl(urlPrefix + 'in-progress.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'in-progress-black',
      this.domSanitizer.bypassSecurityTrustResourceUrl(urlPrefix + 'in-progress-black.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'cloud-shrinked',
      this.domSanitizer.bypassSecurityTrustResourceUrl(urlPrefix + 'cloud-shrinked.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'arrow-forward-ios',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/arrow-forward-ios.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'arrow-back-ios',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/arrow-back-ios.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'file-present',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/file-present.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'star-filled',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/star-filled.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'star-outlined',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/star-outlined.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'folder-upload',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/drive_folder_upload_filled.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'file-copy-sharp',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/file-copy-sharp.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'durable-item',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/durable-item.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'consumable-item',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/consumable-item.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'empty-image',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/empty-image.svg')
    );
    this.matIconRegistry.addSvgIcon('sku', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/sku.svg'));
    this.matIconRegistry.addSvgIcon(
      'crib',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/crib.svg')
    );
    this.matIconRegistry.addSvgIcon('bin', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/bin.svg'));
    this.matIconRegistry.addSvgIcon(
      'supplier',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/supplier.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'purchase-order',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/purchase-order.svg')
    );
  }
}
